import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const ExitSebButton = ({ clickHandler, a11yAttributes }) => {
    return (<OptionButton
        iconClass="fa fa-unlock-alt fa-fw"
        clickHandler={clickHandler}
        title={t('options.exitSeb')}
        a11yAttributes={a11yAttributes}
    />);
};

ExitSebButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    a11yAttributes: PropTypes.object,
};

export default ExitSebButton;
